// Compiled at 2026-10-07T06:21:14.844Z
// Auto-generated by Lowgile
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import type { HasTokenAssignment, LaneAssigneeType } from "@lg/shared";

class $Appraisal {
    static get __type(): 'Toolbox.Appraisal' {
        return 'Toolbox.Appraisal'
    }

    get __type(): 'Toolbox.Appraisal' {
        return 'Toolbox.Appraisal'
    }

    static async start(inputData: $Appraisal.ProcessInputData, startBy?: 'normal') {
        const instanceId = await ExecutionService.executeMethodAndReturnData<string>('Process', 'Toolbox', 'Appraisal', this, 'start', [inputData, startBy])
        return instanceId
    }

    static async startAndGetFirstUserTaskToken(inputData: $Appraisal.ProcessInputData, startBy?: 'normal', taskTimeoutMs?: number, taskDebounceMs?: number) {
        const obj = await ExecutionService.executeMethodAndReturnData<{ instanceId: string, taskToken: Sys.Types.UserTaskToken }>('Process', 'Toolbox', 'Appraisal', this, 'startAndGetFirstUserTaskToken', [inputData, startBy, taskTimeoutMs, taskDebounceMs])
        if (obj?.taskToken) obj.taskToken = new Sys.Types.UserTaskToken(obj.taskToken)
        return obj
    }

    static async startAndNavigateToFirstUserTask(inputData: $Appraisal.ProcessInputData, isNewWindow: boolean | string, startBy?: 'normal', failIfNoUserTask: boolean = true, taskTimeoutMs?: number, taskDebounceMs?: number) {
        const obj = await this.startAndGetFirstUserTaskToken(inputData, startBy, taskTimeoutMs, taskDebounceMs)
        if (obj.taskToken) {
            obj.taskToken = new Sys.Types.UserTaskToken(obj.taskToken)
            await Sys.Process.navigateToTask(obj.taskToken, isNewWindow)
        } else {
            if (failIfNoUserTask) throw new Error(`No user task found for process instance ${obj.instanceId}`)
        }

        return obj
    }
}

namespace $Appraisal {
    export interface ProcessInputData {
    }
}

export { $Appraisal as Appraisal };
